import { injectable } from "inversify";
import { Auth } from 'aws-amplify';
import Constants, { ConstantsName } from "../../constants/Constants";
import di from "../../di/DependencyInjection";

@injectable()
class UserHostApi {
    public url = di.get<Constants>(ConstantsName).HOST_API_USERS_URL;

    private getHeaders = async (): Promise<Record<string, string>> => {
        const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();
        return {
            'Content-Type': 'application/json',
            'Authorization': token,
        };
    };

    public get = async (relativeUrl: string): Promise<any> => {
        const headers = await this.getHeaders();
        const response = await fetch(this.url + relativeUrl, {
            method: 'GET',
            headers,
        });
        if (!response.ok) {
            const error = await response.json().catch(() => ({ message: response.statusText }));
            throw new Error(error.message || 'Request failed');
        }
        return response.json();
    };

    public post = async (relativeUrl: string, body: any): Promise<any> => {
        const headers = await this.getHeaders();
        const response = await fetch(this.url + relativeUrl, {
            method: 'POST',
            headers,
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            const error = await response.json().catch(() => ({ message: response.statusText }));
            throw new Error(error.message || 'Request failed');
        }
        return response.json();
    };

    public put = async (relativeUrl: string, body: any): Promise<any> => {
        const headers = await this.getHeaders();
        const response = await fetch(this.url + relativeUrl, {
            method: 'PUT',
            headers,
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            const error = await response.json().catch(() => ({ message: response.statusText }));
            throw new Error(error.message || 'Request failed');
        }
        return response.json();
    };

    public remove = async (relativeUrl: string): Promise<any> => {
        const headers = await this.getHeaders();
        const response = await fetch(this.url + relativeUrl, {
            method: 'DELETE',
            headers,
        });
        if (!response.ok) {
            const error = await response.json().catch(() => ({ message: response.statusText }));
            throw new Error(error.message || 'Request failed');
        }
        return response.json();
    };
}

export default UserHostApi;

export const UserHostApiName = "UserHostApi";
